module.exports = __webpack_public_path__ + "assets/img/banner09.37e3a684.jpg";